var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("billingPage.ChoseProfileTemplate"),
            visible: _vm.dialogVisible,
            width: "750px",
            "before-close": _vm.handleCancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("billingPage.searchName") } },
                [
                  _c("BjInput", {
                    attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                    model: {
                      value: _vm.form.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "keywords", $$v)
                      },
                      expression: "form.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm._getProfileCategories },
                },
                [_vm._v(_vm._s(_vm.$t("searchText")))]
              ),
              _c(
                "el-table",
                {
                  ref: "refsTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableList, border: "" },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "40" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("billingPage.index"),
                      align: "center",
                      width: "60",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t("billingPage.profileTemplateName"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "gmtCreate",
                      label: _vm.$t("billingPage.lastUpdatedAt"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "gmtUpdate",
                      label: _vm.$t("billingPage.lastUpdatedBY"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("billingPage.usersCount"),
                      align: "center",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openClient(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.clientCodes.length))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1999622947
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSend } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }